import React from 'react';
import { HISTORY, IMAGES } from '../data/mock';
import Reveal from './Reveal';

const HistorySection = () => {
  return (
    <section
      id="history"
      className="relative py-24 md:py-40 px-6 md:px-10 overflow-hidden"
    >
      {/* Faded background image */}
      <div
        role="img"
        aria-label="Candlelit Tudor interior — inspired by the Drudenhaus (Bamberg's 1627 witch prison) at the heart of London's most scary immersive Halloween theatre show."
        className="absolute inset-0 bg-cover bg-center opacity-25"
        style={{ backgroundImage: `url(${IMAGES.history})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0705] via-[#0a0705]/60 to-[#0a0705]" />

      <div className="relative max-w-4xl mx-auto text-center">
        <Reveal>
          <p className="text-[10px] md:text-[11px] tracking-[0.5em] text-[#c8935a] font-fell-sc">
            BAMBERG · 1627
          </p>
        </Reveal>

        <Reveal delay={100}>
          <h2 className="mt-6 font-display text-4xl md:text-6xl text-[#e8dcc0] lowercase leading-tight">
            {HISTORY.heading}
          </h2>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-8 divider-ornament max-w-md mx-auto">
            <span className="text-[9px] tracking-[0.4em] font-fell-sc">DRUDENHAUS</span>
          </div>
        </Reveal>

        <Reveal delay={300}>
          <p className="mt-10 font-fell italic text-2xl md:text-3xl text-[#d9c8a3]">
            {HISTORY.lead}
          </p>
        </Reveal>

        <Reveal delay={400}>
          <p className="mt-6 font-fell text-lg md:text-xl text-[#a89880] leading-[1.85] max-w-2xl mx-auto">
            {HISTORY.body}
          </p>
        </Reveal>

        <Reveal delay={500}>
          <p className="mt-14 font-display text-lg md:text-xl tracking-[0.3em] text-[#e8dcc0] uppercase">
            {HISTORY.emphasis}
          </p>
        </Reveal>

        <Reveal delay={600}>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
            {HISTORY.themes.map((t, i) => (
              <span
                key={i}
                className="font-fell italic text-lg md:text-xl text-[#c8935a]"
              >
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HistorySection;
